export const siteInfo = {
  name: "日本区域指南",
  tagline: "日本一区二区完整指南",
  description: "全面解析日本一区二区的区域划分概念、地理范围与实用信息。为您提供最清晰的区域说明、特色对比与出行参考。",
  url: "https://japan-zone-guide.readdy.ai",
  logo: "日本区域指南",
  email: "contact@japan-zone-guide.com",
  phone: "+81-3-1234-5678",
  address: "日本东京都新宿区西新宿2-8-1",
  social: {
    twitter: "https://twitter.com/japanzoneguide",
    facebook: "https://facebook.com/japanzoneguide",
  },
};

export const navigation = [
  { label: "首页", href: "/" },
  { label: "一区详解", href: "/category/zone-one" },
  { label: "二区详解", href: "/category/zone-two" },
  { label: "区域对比", href: "/category/comparison" },
  { label: "关于我们", href: "/about" },
];

export const footerLinks = {
  categories: [
    { label: "一区详解", href: "/category/zone-one" },
    { label: "二区详解", href: "/category/zone-two" },
    { label: "区域对比", href: "/category/comparison" },
    { label: "出行参考", href: "/category/travel" },
    { label: "生活指南", href: "/category/living" },
  ],
  about: [
    { label: "关于我们", href: "/about" },
    { label: "联系方式", href: "/about#contact" },
    { label: "隐私政策", href: "/privacy" },
    { label: "使用条款", href: "/terms" },
  ],
};